import { EnumLegalEntityRole } from "./legal-entity-info";
import { EnumUserRole } from '../model/user-basic-info';
import { EnumUserLegalEntityRole } from "./user-basic-info";

export class Role {
    id: number | undefined;
    userRole: EnumUserRole;
    legalEntityRole: EnumLegalEntityRole;
    userLegalEntityRole: EnumUserLegalEntityRole;
    roleFullIdentifier: string | undefined;
    
    constructor(userRole?: EnumUserRole, legalEntityRole?: EnumLegalEntityRole | undefined,
        userLegalEntityRole?: EnumUserLegalEntityRole | undefined) {

        this.userRole = userRole || EnumUserRole.NONE;
        this.legalEntityRole = legalEntityRole || EnumLegalEntityRole.NONE;
        this.userLegalEntityRole = userLegalEntityRole || EnumUserLegalEntityRole.NONE;
        this.setRoleFullIdentifier();
    }

    private setRoleFullIdentifier(): void {
        this.roleFullIdentifier = this.userRole + "." + this.legalEntityRole + "." + this.userLegalEntityRole;
    }
}